import { LoadingButton } from '@mui/lab';
import { useEffect } from "react";
import { useState } from "react";

let timer = null;

function TimeoutButton({ time, onClick, onComplete, title,  start, ...props }) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (start) {
      startCountDown();
    } else {
      clearInterval(timer);
      setTimeLeft(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start]);

  const startCountDown = () => {
    setTimeLeft(time);

    timer = setInterval(() => {
      time = time - 1;
      setTimeLeft(time);

      if (time === 0) {
        if (onComplete) {
          onComplete();
        }
        setTimeLeft(null);
        clearInterval(timer);
      }
    }, 1000);
  };

  return (
    <LoadingButton  variant='contained' onClick={onClick} {...props}>
      {title} {timeLeft}
    </LoadingButton>
  );
}

export default TimeoutButton;
